// Icon set mirrored from the frontend so the overlay can render icon-type
// alert media. Keep in sync with frontend/src/utils/icons.js.
const iconModules = import.meta.glob("../assets/icons/*.png", {
  eager: true,
  import: "default",
});

/** @type {Record<string, string>} */
export const ICON_MAP = {};
for (const [path, url] of Object.entries(iconModules)) {
  const name = path.split("/").pop().replace(".png", "");
  ICON_MAP[name] = url;
}
